var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsMobileInvestments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -2110.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Mobile-investments",
    transform: "translate(5026.000000, 2110.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.25,7.375 L24.25,17.5 C24.25,19.985 22.235,22 19.75,22 L19.75,11.875 C19.75,9.39 21.765,7.375 24.25,7.375 L24.25,7.375 Z M13,17.5 C13,15.015 15.015,13 17.5,13 L17.5,17.5 C17.5,19.985 15.485,22 13,22 L13,17.5 Z M31,4 L31,17.5 C31,19.985 28.985,22 26.5,22 L26.5,8.5 C26.5,6.015 28.515,4 31,4 L31,4 Z M11.5,30 C10.671,30 10,29.328 10,28.5 C10,27.672 10.671,27 11.5,27 C12.329,27 13,27.672 13,28.5 C13,29.328 12.329,30 11.5,30 L11.5,30 Z M18,26 L4,26 L4,3.999 L18,3.999 L18,6 L21,6 L21,0 L5,0 C2.791,0 1,1.791 1,4 L1,32 L17,32 C19.209,32 21,30.209 21,28 L21,24 L18,24 L18,26 Z",
    id: 9
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsMobileInvestments);
export default __webpack_public_path__ + "static/media/investments-mobile-investments.19a7cffa.svg";
export { ForwardRef as ReactComponent };